import { RepassesDialogComponent } from '../../shared/components/repasses-dialog/repasses-dialog.component';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { EtapasBeneficioComponent } from '../../shared/components/etapas-beneficio/etapas-beneficio.component';
import { AcrescimosService } from '../../core/services/acrescimos.service';
import { SessionService } from '../../core/services/session.service';

@Component({
  selector: 'app-acrescimos',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatProgressBarModule,
    EtapasBeneficioComponent,
  ],
  templateUrl: './acrescimos.component.html',
  styleUrl: './acrescimos.component.scss',
})
export class AcrescimosComponent implements OnInit {
  beneficiario: any = '';
  loading = true;
  acrescimos: any[] = [];

  displayedColumns: string[] = [
    'tipo',
    'descricao',
    'inicio',
    'fim',
    'totalDias',
    'diasAcrescentar',
    'diasDeduzir',
    'totalAproveitado',
    'status',
    'acoes',
  ];

  // Modais
  @ViewChild('modalUpload') modalUpload!: TemplateRef<any>;

  // Upload state
  selectedFile: File | null = null;
  uploading = false;
  acrescimoSelecionado: any = null;
  private dialogRef?: MatDialogRef<any>;

  constructor(
    private acrescimosService: AcrescimosService,
    private sessionService: SessionService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  editarRepasses(registro:any): void {
    this.dialog.open(RepassesDialogComponent,{width:'950px',maxWidth:'98vw',data:{justificativa:registro.justificativa,tipo:'acrescimo',id:registro.id,matricula:this.beneficiario.matricula,idOrgao:this.beneficiario.orgao.id}}).afterClosed().subscribe(salvou=>{if(salvou)this.atualizarDados(true);});
  }

  atualizando = false;
  atualizarDados(repassesSalvos = false): void {
    if (this.atualizando) return;
    this.atualizando = true;
    this.acrescimosService.atualizar(this.beneficiario.matricula, this.beneficiario.orgao.id).subscribe({
      next: dados => {
        this.acrescimos = dados; this.atualizando = false;
        this.snackBar.open('Dados atualizados e salvos.', 'Fechar', {duration: 3000});
        this.carregarResumo();
      },
      error: err => {
        this.atualizando = false;
        this.snackBar.open(repassesSalvos ? 'Repasses salvos. Não foi possível atualizar os tempos; tente Atualizar e Salvar Dados.' : (err.error?.message ?? err.error?.detail ?? 'Não foi possível atualizar os dados.'), 'Fechar', {duration: 5000});
      }
    });
  }

  resumo: {totalDiasConcomitantes:number,totalLiquido:number} | null = null;
  erroResumo = '';
  carregarResumo(): void {
    this.resumo = null; this.erroResumo = '';
    this.acrescimosService.resumo(this.beneficiario.matricula, this.beneficiario.orgao.id).subscribe({
      next: resumo => this.resumo = resumo,
      error: () => this.erroResumo = 'Não foi possível apurar o resumo dos acréscimos.'
    });
  }

  ngOnInit(): void {
    this.beneficiario = this.sessionService.beneficiario;

    this.acrescimosService
      .getAcrescimos(this.beneficiario.matricula, this.beneficiario.orgao.id)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.acrescimos = res;
          this.carregarResumo();
        },
        error: (err: any) => {
          this.loading = false;
          console.error('Erro ao buscar acrescimos', err);
        },
      });
  }


  abrirModalUpload(item: any): void {
    this.acrescimoSelecionado = item;
    this.selectedFile = null;
    this.uploading = false;

    this.dialogRef = this.dialog.open(this.modalUpload, {
      data: item,
    });
  }

  onFileSelected(event: any): void {
    const file = event.target?.files?.[0];
    this.selectedFile = file || null;
  }

  private getIdOrigemFromAcrescimo(a: any): number {
    // Preferir o idOrigemAcrescimo; fallback para id (ou outro campo se existir)
    return a?.idOrigemAcrescimo;
  }

  enviarDocumento(): void {
    if (!this.selectedFile || !this.acrescimoSelecionado) return;

    const idOrigem = this.getIdOrigemFromAcrescimo(this.acrescimoSelecionado);
    if (!idOrigem) {
      this.snackBar.open(
        'Não foi possível identificar o id de origem do acréscimo.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );
      return;
    }

    // >>> AQUI o tipoDocumento vem do enum do item (ex.: "FERIAS")
    const tipo = this.acrescimoSelecionado.enumTipoAcrescimoPrevidenciario;
    const tipoDocumento = typeof tipo === 'string' ? tipo : 'ACRESCIMO';
    const idTipoDocumento = typeof tipo === 'object' ? tipo?.tipoDocumento : undefined;
    if (!idTipoDocumento && typeof tipo !== 'string') {
      this.snackBar.open('Tipo documental do acréscimo não informado.', 'Fechar', {duration: 5000});
      return;
    }

    this.uploading = true;
    this.acrescimosService
      .uploadAcrescimoDocumento(idOrigem, this.selectedFile, tipoDocumento, idTipoDocumento)
      .subscribe({
        next: (res: any) => {
          this.uploading = false;
          if (/^(erro|falha|não foi possível)/i.test(res?.message?.trim() ?? '')) {
            this.snackBar.open(res.message, 'Fechar', {duration: 5000});
            return;
          }
          this.acrescimosService
            .getAcrescimos(
              this.beneficiario.matricula,
              this.beneficiario.orgao.id
            )
            .subscribe({
              next: (res: any) => {
                this.loading = false;
                this.acrescimos = res;
                this.carregarResumo();
              },
              error: (err: any) => {
                this.loading = false;
                console.error('Erro ao buscar acrescimos', err);
              },
            });
          this.snackBar.open('Documento enviado com sucesso ✅', 'Fechar', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });


          this.dialogRef?.close();
        },
        error: (err) => {
          this.uploading = false;
          console.error('Erro ao enviar documento', err);
          this.snackBar.open('Falha ao enviar documento ❌', 'Fechar', {
            duration: 4000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        },
      });
  }

  downloadFile(a: any): void {
    const hash = a?.hashDoc || a?.hash;
    if (!hash) {
      this.snackBar.open(
        'Nenhum documento anexado neste acréscimo.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );
      return;
    }

    this.acrescimosService.downloadDocumentoPorHash(hash).subscribe({
      next: (res) => {
        const blob = res.body as Blob;
        const cd =
          res.headers.get('Content-Disposition') ||
          res.headers.get('content-disposition') ||
          '';
        const match = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(cd);
        const filenameFromHeader = match ? decodeURIComponent(match[1]) : null;
        const fallback = `acrescimo_${
          a.idOrigemAcrescimo ?? a.id ?? 'documento'
        }.pdf`;
        const filename = filenameFromHeader || fallback;

        const url = window.URL.createObjectURL(blob);
        const el = document.createElement('a');
        el.href = url;
        el.download = filename;
        document.body.appendChild(el);
        el.click();
        el.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Erro ao baixar documento', err);
        this.snackBar.open('Falha ao baixar documento.', 'Fechar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      },
    });
  }

  deletarDocumento(a: any): void {
    const hash = a?.hashDoc || a?.hash;
    if (!hash) {
      this.snackBar.open(
        'Nenhum documento para excluir neste acréscimo.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );
      return;
    }

    this.acrescimosService.deleteDocumentoPorHash(hash).subscribe({
      next: () => {
        this.snackBar.open('Documento excluído com sucesso ✅', 'Fechar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
        this.acrescimosService
          .getAcrescimos(
            this.beneficiario.matricula,
            this.beneficiario.orgao.id
          )
          .subscribe({
            next: (res: any) => {
              this.loading = false;
              this.acrescimos = res;
          this.carregarResumo();
            },
            error: (err: any) => {
              this.loading = false;
              console.error('Erro ao buscar acrescimos', err);
            },
          });
        a.hashDoc = null;
        if ('hash' in a) a.hash = null;
      },
      error: (err) => {
        console.error('Erro ao excluir documento', err);
        this.acrescimosService
          .getAcrescimos(
            this.beneficiario.matricula,
            this.beneficiario.orgao.id
          )
          .subscribe({
            next: (res: any) => {
              this.loading = false;
              this.acrescimos = res;
          this.carregarResumo();
            },
            error: (err: any) => {
              this.loading = false;
              console.error('Erro ao buscar acrescimos', err);
            },
          });
        this.snackBar.open('Não foi possível excluir o documento. Tente novamente.', 'Fechar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      },
    });
  }

  calcularTotal(acre: any): number {
    const total =
      (acre?.qtdDiasAcrecimo ?? 0) - (acre?.qtdDiasOutrasDeducoes ?? 0);
    return total;
  }

  getStatus(acre: any): string {
    if (acre?.statusDoc) return acre.statusDoc; // usa o status do backend se vier
    const total =
      (acre?.qtdDiasAcrecimo ?? 0) - (acre?.qtdDiasOutrasDeducoes ?? 0);
    return total > 0 ? 'Aproveitado' : 'Parcial';
  }

}
